export default __webpack_public_path__ + "static/media/tiger.f93faa51.jpg";